import React from "react";
import { NewsEventModel } from "../../../domain/entities/NewsEventModel";
import NewsEventItemComponents from "./NewsEventItemComponents";
import { useNavigate } from "react-router-dom";

interface NewsEventListProps {
    newsList: NewsEventModel[]
}

const NewsEventListComponents: React.FC<NewsEventListProps> = ({newsList}) => {

    const navigate = useNavigate();
    const handleClickAll = () => {
        navigate("/listnews");
    }

    return (
        // Main container with relative positioning and centering
        <div className="w-full max-w-7xl mx-auto px-4 py-4 md:py-6 relative">
            {/* Heading */}
            <h4 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-8 font-poppins">
                Berita dan Acara
            </h4>

            {/* Scroll container with position relative for overlay positioning */}
            <div className="relative">
                {/* Scrollable area with no padding to prevent cropping */}
                <div className="overflow-x-auto md:scroll-smooth">
                    {/* Content wrapper with padding to create space from edges */}
                    <div className="flex flex-col md:inline-flex md:flex-row gap-6 md:gap-8 px-4 mb-10 justify-center">
                        {newsList.map((item) => (
                            <div 
                                key={item.id} 
                                className="w-full md:w-96 flex-shrink-0 flex justify-center"
                            >
                                <NewsEventItemComponents 
                                    newsEvent={item} 
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Button Container - Positioned at bottom right */}
            <div className="absolute bottom-2 right-8 md:right-20">
                <button
                    className="bg-[#9b284c] text-white text-xs rounded-lg px-2.5 py-1.5 md:px-4 md:py-2 font-bold hover:bg-[#801d3e] transition-all flex items-center gap-1 font-poppins"
                    onClick={handleClickAll}
                >
                    Lihat Semua
                </button>
            </div>
        </div>
    );
}

export default NewsEventListComponents;